import { Navigate } from 'react-router-dom';
import { useAuth } from '@/auth/AuthContext';

export default function LandingPage() {
  const { user } = useAuth();

  if (user?.role === 'CLIENT') return <Navigate to="/portal" replace />;
  if (user) return <Navigate to="/admin" replace />;

  return <Navigate to="/login" replace />;
}
